<template>
  <div class="tech">
    <!-- 页眉标题 -->
    <el-row class="title">
      <!-- 在PC上显示标准名称， 在手机端显示标准号 -->
      <el-col :span="22">
        <span class="title_text">系列标准介绍</span>
      </el-col>
      <el-col :span="2" style="text-align:right">
        <el-dropdown trigger="click">
          <img src="static/images/1DING-MINLOG.svg" type="image/svg+xml" class="logo">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="menu('home')">网站首页 / 常规搜索</el-dropdown-item>
            <el-dropdown-item @click.native="menu('advanceSearch')">高级搜索 / 精准搜索</el-dropdown-item>
            <!-- <el-dropdown-item @click.native="menu('standards')" class="left show-md-and-up-only">国内标准 / 国际标准</el-dropdown-item>
            <el-dropdown-item @click.native="menu('regulations')" class="left show-md-and-up-only">法律法规 / 监管要求</el-dropdown-item> -->
            <el-dropdown-item divided @click.native="user('regulations')" class="left show-md-and-up-only">个人中心 / 消费记录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <el-row>
      <el-col :md=8 :lg=6 class="left show-md-and-up-only">
        <ul>
          <li>
            <router-link :to="{path:'/tech',query:{techid:'tech20190415'}}">
              <p style="font-weight:700">1DING GRC 4月15日试运行上线</p>
              <p>精准搜索监管机构针对某一具体事项（如日志、备份）都提出过哪些具体要求，落在哪份文件，在哪个条款。</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path:'/tech',query:{techid:'tech20190504'}}">
              <p style="font-weight:700"> 您知道吗，截止2019年4月，ISO27000系列已经正式发布52条标准了。</p>
              <p> 这52项标准除了涵盖覆盖了常规的术语概念、基本要求、风险管理、实施指南之外，
                还对数据处理（包括数据编辑、数据交互、个人隐私）、云服务安全、存储安全、应用安全、网络安全、供方安全、安全事件、调查取证（包括电子证据和电子举证）、应急管理等领域制定了响应的标准</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path:'/tech',query:{techid:'tech20190513'}}">
              <p style="font-weight:700"> 不经意间， ISO22301/业务连续性管理体系已经发布的标准超过20条了。</p>
              <p> ISO223XX系列标准从BSI发布的BCM英国标准PAS56:2003开始，经过近17年的发展，截止2019年4月30日，已经正式发布的标准共有22项。其中有3项已经被吸纳为国家标准。</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path:'/tech',query:{techid:'tech20190522'}}">
              <p style="font-weight:700"> 迄今为止， ISO20000/信息技术服务管理体系已经发布10条标准了。</p>
              <p> ISO20000系列标准从BSI发布的英国标准BS15000:1995开始，经过近24年的发展，截止2019年4月30日，已经正式发布的标准有10项了，其中有2项已经被吸纳为国家标准。已发布的10项标准除了覆盖常规的术语概念、基本要求、实践指南、审核要求之外，还对具体的云服务行业、实施过程和体系融合等方面制定了相应的标准。</p>
            </router-link>
          </li>
        </ul>
      </el-col>
      <el-col :x=24 :sm=24 :md=16 :lg=18 class="right hideScrollbar">
        <div v-if="techid=='tech20190415'">
          <tech20190415 />
        </div>
        <div v-if="techid=='tech20190504'">
          <tech20190504 />
        </div>
        <div v-if="techid=='tech20190513'">
          <tech20190513 />
        </div>
        <div v-if="techid=='tech20190522'">
          <tech20190522 />
        </div>
      </el-col>
    </el-row>
    <div class="show-md-and-up-only">
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  import tech20190504 from "@/components/tech/tech20190504.vue"
  import tech20190415 from "@/components/tech/tech20190415.vue"
  import tech20190513 from "@/components/tech/tech20190513.vue"
  import tech20190522 from "@/components/tech/tech20190522.vue"
  export default {
    components: {
      tech20190415,
      tech20190504,
      tech20190513,
      tech20190522
    },
    computed: {
      techid() {
        if (this.$route.query.techid) {
          return this.$route.query.techid
        } else {
          return 'tech20190522'
        }
      }
    },
    methods: {
      menu(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/" + params
        });
        window.open(href, "_blank");
      },
      user() {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
      }
    }
  }
</script>

<style scope>
  .tech {
    -webkit-overflow-scrolling: touch;
  }

  .tech .title {
    margin: 0.2rem 0;
    border-bottom: 1px solid gray;
  }

  .tech .title_text {
    position: relative;
    padding: 0.02rem;
    font-size: 0.15rem !important;
    font-weight: 900 !important;
  }

  .tech .title_text:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 5px;
    left: 0;
    bottom: -5px;
    background: #aa0000;
  }

  .tech .logo {
    margin: -0.05rem 0;
    height: 0.2rem;
    cursor: pointer;
  }

  .tech .left {
    height: calc(100vh - 1rem);
    overflow: auto;
    border-right: 1px solid #aa0000
  }

  .tech ::-webkit-scrollbar { 
    display:none
  }

  .tech .right {
    padding: 0 0.1rem 0 0.05rem;
    height: calc(100vh - 1rem);
    overflow: "hideScrollbar";
  }

  .tech ul {
    margin: 0.1rem;
    padding: 0.1rem;
  }
</style>